/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Card from 'react-bootstrap/Card';
import Media from 'react-bootstrap/Media';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCompanyDetails } from 'store/common/slices/profile';
import { Background } from 'layout';
import { AuthenticateLogo, Button } from 'ui';
import WelcomeHighlights from '../../components/WelcomeHighlights';
import styles from './Lander.module.css';

export default function Lander() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    React.useEffect(() => {
        dispatch(
            setCompanyDetails({
                company: {
                    name: 'Authenticating.com',
                },
            })
        );
    }, []);

    return (
        <Background className={styles.welcomeCard}>
            <Card.Header className={styles.cardHeaderWrapper}>
                <Media className={styles.cardHeader}>
                    <Media.Body>
                        <div>
                            <b>Medallion™</b>
                        </div>
                    </Media.Body>
                </Media>
            </Card.Header>
            <Card.Body className={styles.body}>
                <div>
                    <p className={styles.cardheading}>
                        <b>Use Authenticating.com to quickly verify your identity.</b>
                    </p>
                    <WelcomeHighlights />
                </div>
            </Card.Body>
            <Card.Footer
                style={{ background: '#FFFFFF', border: 'none', padding: '20px 15px 24px' }}
            >
                <Row>
                    <Col>
                        <Button
                            block
                            variant="outline-primary"
                            className={styles.footerBtn}
                            onClick={() =>
                                window.open(
                                    'https://portal.authenticating.com/register',
                                    '_blank',
                                    'noopener'
                                )
                            }
                        >
                            Get API key
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            block
                            className={styles.footerBtn}
                            variant="primary"
                            onClick={() => navigate('/onboarding')}
                        >
                            <AuthenticateLogo />
                        </Button>
                    </Col>
                </Row>
            </Card.Footer>
        </Background>
    );
}
